import * as React from 'react';
import AppDocumentTitle from 'login-components/Common/AppDocumentTitle/AppDocumentTitle';
import FormDialog from 'login-components/Common/Form/FormDialog/FormDialog';
import AppFooterUpdater from 'login-components/Common/AppFooterUpdater';

interface WrapperOwnProps {
  footerConfig: FooterConfig | null;
}

export default class AppDocumentWrapper extends React.Component<WrapperOwnProps, {}> {
  render() {
    const { footerConfig, children } = this.props;
    return (
      <AppDocumentTitle title="Login">
        <AppFooterUpdater footerConfig={footerConfig}>
          <FormDialog>{children}</FormDialog>
        </AppFooterUpdater>
      </AppDocumentTitle>
    );
  }
}
